import { useEffect, useRef, useState } from "react";
import { observer } from "mobx-react";

import { MARKET_MODES } from "market";

import "./DropDownList.scss";

export const DropDownList = observer(({ store, error, textareaReviewRef }) => {
  const itemsContainer = useRef();
  const [isExpanded, setIsExpanded] = useState(false);
  const [itemsContainerStyle, setItemsContainerStyle] = useState();

  const reviewsMode = store.market.modes.find(mode => mode.id === MARKET_MODES.REVIEWS);
  const onlineServices = reviewsMode?.listOnlineServices || [];

  useEffect(() => {
    setItemsContainerStyle({ height: itemsContainer.current.scrollHeight, border: '1px solid #d7e2e4', borderTop: 'none' });
  }, [store]);

  const handleServiceSelect = (service) => {
    store.setSelectedOnlineService({ title: service.title, text: service.text });
    
    if (service.title !== "Своя услуга") {
      if (textareaReviewRef.current) {
        textareaReviewRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }
    
    setIsExpanded(false);
  };

  return (
    <div className={`drop-down-list ${isExpanded ? "drop-down-list_expanded" : ""}`} tabIndex={0} onClick={() => { setIsExpanded(!isExpanded) }} onBlur={() => { setIsExpanded(false) }}>
      <div className={`drop-down-list__container ${error ? "error" : ""}`}>
        <div className="drop-down-list__container-title">
          {store.selectedOnlineService 
            ? <>
                <p className={`${onlineServices ? "other-color" : ""}`}>{store.selectedOnlineService.title}</p>
                <p className="drop-down-list__container-text">{store.selectedOnlineService.text}</p>
              </>
            : <p>Выберите из популярных услуг</p>
          }
        </div>
      </div>

      <div className="drop-down-list__items" ref={itemsContainer} style={isExpanded ? itemsContainerStyle : {}}>
        {onlineServices.map((service, i) => (
          <div  className="drop-down-list__item" key={i} onClick={() => handleServiceSelect(service)}>
            <p className="drop-down-list__item-title">{service.title}</p>
            <p className="drop-down-list__item-text">{service.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
});
